import { render, staticRenderFns } from "./DealerRoReport.vue?vue&type=template&id=d5bf9c3a&"
import script from "./DealerRoReport.vue?vue&type=script&lang=js&"
export * from "./DealerRoReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports